import buildSubjectListPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectListPath';
import type { NavigationMenuEntry } from '@UI/Routing/navigationMenu';
import type SubjectTypeView from '@UI/Store/SubjectTypes/Views/SubjectTypeView';
import resolveSubjectTypeIcon from '@Guidelines/Component/SubjectTypeTile/Helpers/resolveSubjectTypeIcon';

/** One menu entry per subject type, in the order given, each opening the type's list. */
const buildSubjectMenuEntries = (types: readonly SubjectTypeView[]): readonly NavigationMenuEntry[] => {
	return types.map((type) => ({
		id: `subject:${type.key}`,
		label: type.wording.plural,
		icon: resolveSubjectTypeIcon(type.icon.value),
		destinations: [
			{
				path: buildSubjectListPath(type.key),
				label: type.wording.plural,
				icon: resolveSubjectTypeIcon(type.icon.value),
				permissions: [],
			},
		],
	}));
};

export default buildSubjectMenuEntries;
